import React from "react";
import { Empty } from "antd";

class Series extends React.Component {
  componentDidMount() {}

  render() {
    const { title } = this.props;
    return (
      <div>
        <h4 style={{ color: "#000", fontWeight: "bold", fontSize: "16px" }}>
          {title}
        </h4>
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
      </div>
    );
  }
}

export default Series;



// WEBPACK FOOTER //
// ./src/components/comm/charts/Empty.js